module.exports = __webpack_public_path__ + "static/media/image2.17da02b6.jpg";